var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.extra)?_c('div',{staticClass:"extras"},[_c('div',{staticClass:"breadcrumbs"},[_c('h2',[_vm._v("Edit "+_vm._s(_vm.extra.title))])]),_c('ExtraForm',{attrs:{"saving":_vm.saving,"extra":_vm.extra},on:{"save":_vm.save}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }